module.exports = __webpack_public_path__ + "img/failed.ae3a431b.svg";